function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 82 94"
}, props), React.createElement("path", {
  d: "M49.945 11.169c-.063 2.014-.595 6.864 1.92 10.381 4.036 5.645 12.767 18.352 15.074 21.628.69.979 1.158 2.07 1.277 3.22.198 1.914-.476 4.438-4.837 5.488-7.288 1.758-8.501 5.56-7.954 8.233.547 2.673 2.434 7.084-2.498 9.211M40.983 71.663s5.456-2.482 9.667-2.49c3.251 0 5.337 3.178 3.497 5.574-.016.022-.04.05-.056.071 0 0-.483.646-1.015 1.66-1.102 2.12-1.237 4.517-.594 6.786.808 2.843.578 7.963-11.5 7.963h-7.129",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M50.301 2S63.172 16.225 20.92 17.012c-4.02.078-7.93.475-11.174 1.553-5.218 1.73-10.23 5.325-6.391 12.714M18.335 92c2.498-9.176 2.95-20.543 2.879-28.591-.048-5.744 4.932-10.516 11.34-10.9l10.999-.659s11.23-.149 14.401-6.708",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M6.732 92c3.458-7.722 3.648-17.586 3.632-26.4-.023-12.246 11.158-22.153 24.854-22.153h6.74s8.327.12 9.651-4.425",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M42.03 38.66c1.206 0 2.411-.12 3.577-.36a.952.952 0 00.698-.525.787.787 0 00-.056-.816 3089.782 3089.782 0 00-9.405-14.331s.024.07.047.206c.31 1.787 1.142 9.778-3.917 11.104-3.688.965-9.27 2.503-12.657 7.425h.008c4.346-1.759 9.096-2.695 14.005-2.695h7.692l.008-.007zM47.858 85.653c.215-.248.151-.85.008-1.333-.587-2.063-.682-4.17-.301-6.169 0 0-3.688 6.02-13.72 8.821h7.13c4.52 0 6.447-.836 6.875-1.326l.008.007z",
  fill: "#357287"
}), React.createElement("path", {
  d: "M72.268 54.829l7.731 6.85M69.802 60.246l6.67 7.488M64.107 62.926l3.172 4.433",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));